<template lang="pug">
.service-list-item.media
  .media-left(v-if="image")
    cl-img.avatar(
      :cl-id="image.cl_id"
      :transform="{ width: 96, height: 96, crop: 'thumb' }"
    )
  .media-content
    p.is-size-6 {{ service.title }}
    small.has-text-grey
      span {{ service.frequency | serviceFrequency }} {{ service.weekday | serviceWeekday(service.frequency) }}
      span {{ service.end_time ? ' from ' : ' at ' }}
      span {{ service.start_time | date('h:mm A') }}
      span(v-if="service.end_time") &ndash;{{ service.end_time | date('h:mm A') }}
</template>

<script>
import { mapGetters } from 'vuex';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'service-list-item',
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
    }),
    image() {
      if (this.service.profile_image) return this.service.profile_image;
      if (this.account._embedded.logo) return this.account._embedded.logo;
      return null;
    },
    service() {
      return this.value;
    },
  },
  props: {
    value: {
      type: Object,
      default() {
        return {};
      },
    },
  },
};
</script>

<style lang="scss">
.service-list-item {
  align-items: center;
  & + .service-list-item {
    margin-top: 0;
    border-top: 0;
    // padding-top: 0.75rem;
  }
  .avatar {
    border-radius: 100%;
    width: 48px;
    height: 48px;
  }
  .media-content {
    p {
      margin-bottom: 0;
    }
  }
}
</style>
